import {
  Typography,
  Tag,
  Table,
  Tabs,
  Row,
  Col,
  Space,
  Badge,
  Spin,
} from "antd";
import { useShow, useTranslate } from "@refinedev/core";
import { Link } from "react-router-dom";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  ProductOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import { BuildingOfficeIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { GlassCard } from "../../shared/components";

const { Title, Text } = Typography;

export const PricingPlanShow = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;
  const _t = useTranslate();

  const record = data?.data;

  useEffect(() => {
    record?.pricingPlanProducts?.forEach((pp: any) => {
      console.log("Pricing Plan", pp);
    });
  }, [record]);

  const productColumns = [
    {
      title: _t("products.fields.name"),
      dataIndex: ["product", "name"],
      key: "productName",
      render: (text: string, record: any) => {
        console.log("Recordame", record);
        return <Link to={`/products/show/${record.product.id}`}>{text}</Link>;
      },
    },
    {
      title: _t("products.fields.type"),
      dataIndex: ["product", "type"],
      key: "productType",
      render: (type: string) => (
        <Tag color={type === "base" ? "blue" : "green"}>
          {_t(`products.fields.typeValues.${type}`)}
        </Tag>
      ),
    },
    {
      title: _t("pricing-plans.fields.customPrice"),
      dataIndex: "price",
      key: "price",
      render: (price: number) => <Text strong>{price || "0"}</Text>,
    },
  ];

  const accountColumns = [
    {
      title: _t("accounts.fields.name"),
      dataIndex: "name",
      key: "name",
      render: (text: string, record: any) => {
        return <Link to={`/accounts/show/${record.id}`}>{text}</Link>;
      },
    },
    {
      title: _t("accounts.fields.type"),
      dataIndex: "type",
      key: "type",
      render: (type: string) => (
        <Tag color={type === "company" ? "blue" : "green"}>
          {_t(`accounts.fields.typeValues.${type}`)}
        </Tag>
      ),
    },
  ];

  const tabItems = [
    {
      key: "overview",
      label: (
        <Space>
          <InfoCircleOutlined />
          {_t("titles.overview")}
        </Space>
      ),
      children: (
        <Row gutter={[24, 16]}>
          <Col xs={24} md={12}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <Text type="secondary">{_t("pricing-plans.fields.name")}</Text>
              <Title level={4} style={{ margin: 0 }}>
                {record?.name}
              </Title>
            </Space>
          </Col>
          <Col xs={24} md={12}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <Text type="secondary">
                {_t("pricing-plans.fields.isActive")}
              </Text>
              <Tag
                color={record?.isActive ? "green" : "red"}
                icon={
                  record?.isActive ? (
                    <CheckCircleOutlined />
                  ) : (
                    <CloseCircleOutlined />
                  )
                }
              >
                {record?.isActive ? _t("titles.yes") : _t("titles.no")}
              </Tag>
            </Space>
          </Col>
          <Col xs={24}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <Text type="secondary">
                {_t("pricing-plans.fields.description")}
              </Text>
              <Text>{record?.description || _t("titles.noDescription")}</Text>
            </Space>
          </Col>
        </Row>
      ),
    },
    {
      key: "products",
      label: (
        <Space>
          <ProductOutlined />
          {_t("pricing-plans.fields.products")}
          <Badge count={record?.pricingPlanProducts?.length || 0} />
        </Space>
      ),
      children: (
        <Table
          columns={productColumns}
          dataSource={record?.pricingPlanProducts || []}
          rowKey="id"
          pagination={false}
          locale={{
            emptyText: _t("pricing-plans.titles.noProducts"),
          }}
        />
      ),
    },
    {
      key: "accounts",
      label: (
        <Space>
          <BuildingOfficeIcon className="h-4 w-4" />
          {_t("pricing-plans.fields.accounts")}
          <Badge count={record?.accounts?.length || 0} />
        </Space>
      ),
      children: (
        <Table
          columns={accountColumns}
          dataSource={record?.accounts || []}
          rowKey="id"
          pagination={false}
          locale={{
            emptyText: _t("pricing-plans.titles.noAccounts"),
          }}
        />
      ),
    },
  ];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <GlassCard
        title={record?.name || _t("pricing-plans.fields.name")}
        icon={<TagsOutlined />}
        className="backdrop-blur-md bg-white/5 border border-white/10 shadow-xl"
      >
        <Tabs
          className="-mt-4"
          items={tabItems}
          defaultActiveKey="overview"
          size="large"
        />
      </GlassCard>
    </div>
  );
};
